export default __webpack_public_path__ + "static/media/774.54de0d83.gif";